import { render, staticRenderFns } from "./bhakti-promotion.vue?vue&type=template&id=6b4c84bb&scoped=true"
import script from "./bhakti-promotion.vue?vue&type=script&lang=js"
export * from "./bhakti-promotion.vue?vue&type=script&lang=js"
import style0 from "./bhakti-promotion.vue?vue&type=style&index=0&id=6b4c84bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c84bb",
  null
  
)

export default component.exports